import React from "react";
import "./styles.scss";
import { getAutomationDataAttr } from "../../../utils/automationUtils";

const Toggle = (props) => {
  const enabledText = props.enabledText ? props.enabledText : "On";
  const disabledText = props.disabledText ? props.disabledText : "Off";

  return (
    <div
      className={`toggle-container mb-2 ${props.className}`}
      onClick={props.toggleSelected}
      {...getAutomationDataAttr(props.testId)}
    >
      <div
        className={`dialog-button dialog-button-on ${
          props.selected ? "toggle-button-enabled-on" : "toggle-button-disabled"
        }`}
        {...getAutomationDataAttr(props.testId ? `${props.testId}Enabled` : undefined)}
      >
        {enabledText}
      </div>
      <div
        className={`dialog-button ${
          props.selected ? "toggle-button-disabled" : "toggle-button-enabled-off"
        }`}
        {...getAutomationDataAttr(props.testId ? `${props.testId}Disabled` : undefined)}
      >
        {disabledText}
      </div>
    </div>
  );
};

export default Toggle;
